import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ILoaiQuyHoach } from 'app/shared/model/loai-quy-hoach.model';
import { searchEntities, getEntities } from './loai-quy-hoach.reducer';

export const LoaiQuyHoach = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const loaiQuyHoachList = useAppSelector(state => state.loaiQuyHoach.entities);
  const loading = useAppSelector(state => state.loaiQuyHoach.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="loai-quy-hoach-heading" data-cy="LoaiQuyHoachHeading">
        <Translate contentKey="xtdtApp.loaiQuyHoach.home.title">Loai Quy Hoaches</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.loaiQuyHoach.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/loai-quy-hoach/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.loaiQuyHoach.home.createLabel">Create new Loai Quy Hoach</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.loaiQuyHoach.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {loaiQuyHoachList && loaiQuyHoachList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.loaiQuyHoach.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.loaiQuyHoach.ten">Ten</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {loaiQuyHoachList.map((loaiQuyHoach, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/loai-quy-hoach/${loaiQuyHoach.id}`} color="link" size="sm">
                      {loaiQuyHoach.id}
                    </Button>
                  </td>
                  <td>{loaiQuyHoach.ten}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/loai-quy-hoach/${loaiQuyHoach.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/loai-quy-hoach/${loaiQuyHoach.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/loai-quy-hoach/${loaiQuyHoach.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.loaiQuyHoach.home.notFound">No Loai Quy Hoaches found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default LoaiQuyHoach;
